// import { makeStyles } from "@mui/material/styles";
import { makeStyles } from '@mui/styles'; // https://stackoverflow.com/questions/72495622/npm-install-of-mui-styles-is-not-working-for-react-18

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: "flex",
    alignItems: "center",
    marginBottom: 24,
    width: "100%",
    justifyContent: "flex-end",
  },
  header: {
    width: "100%",
    textAlign: "center",
  },
  item: {
    marginLeft: 20,
    marginRight: 20,
  },
  printImg: {
    width: '70px', 
    height: '111px',
    '@media print': {
      width: '95px', 
      height: '150px' ,
      margin: 0
    },
  },
  printWrapper: {
    '@media print': {
      // NOTE: display:flex + height:100vh looked perfectly centered on
      // screen, but Chrome's print engine does not reliably fragment
      // flex containers across forced page breaks -- it can silently
      // drop content or split a table across two pages. Block layout
      // paginates predictably, so vertical "centering" here is just a
      // fixed top offset (approximate, not measured) rather than a true
      // center -- reliable placement matters more than a perfect middle.
      display: "block",
      width: '100% !important',
      height: 'auto !important',
      textAlign: "center",
      margin: '0 !important',
      paddingTop: 'var(--print-pad-top, 150px)',
    },
    display: "inline-flex",
  },
  printTableWrapper: {
    '@media print': {
      backgroundColor: "white",
      height: 'auto !important',
      margin: '0 auto',
      padding: 0,
      overflowY: "hidden",
      overflowX: "hidden"
    },

  },

}));

export default useStyles;